export default __webpack_public_path__ + "static/media/cyspaceglobalimage.5bbae2b9.jpeg";